import { BrandConfig } from '@ui/config/brand';
import type { TFunction } from 'next-i18next';

import { ROUTES } from './routes';

type PageMeta = {
  title?: string;
  description?: string;
  canonical?: string;
  ogImageUrl?: string;
  siteName?: string;
  card?: string;
  type?: string;
  twitterSite?: string;
  twitterImage?: string;
};

export const getPageMeta = (
  t: TFunction,
  brand: BrandConfig,
  pageRoute?: ROUTES,
  suffix?: string,
): Pick<PageMeta, 'title' | 'description'> => {
  let title = brand.title;
  let subtile = '';
  let description = brand.description;

  switch (pageRoute) {
    case ROUTES.INDEX:
      subtile = t('common.Trade');
      break;
    case ROUTES.PORTFOLIO:
      subtile = t('common.Portfolio');
      break;
    // case ROUTES.ABOUT:
    //   subtile = t('common.About');
    //   break;
    // case ROUTES.NOT_FOUND:
    //   subtile = t('common.Not Found');
    //   break;
    // case ROUTES.PORTFOLIO_EARN:
    //   subtile = t('common.Portfolio | Earn');
    //   break;
    // case ROUTES.PORTFOLIO_TRADE:
    //   subtile = t('common.Portfolio | Trade');
    //   break;
    case undefined:
      break;
    default:
      break;
  }
  if (subtile) {
    title = `${subtile} | ${brand.title}`;
  }
  if (suffix) {
    title += `${subtile} ${suffix}`;
  }

  return {
    title,
    description,
  };
};

export const getMeta = (
  t: TFunction,
  pageRoute: ROUTES,
  brand: BrandConfig,
): PageMeta => {
  const { title, description } = getPageMeta(t, brand, pageRoute);

  return {
    title,
    description,
    ogImageUrl: brand.previewImageUrl,
    card: 'summary_large_image',
    siteName: brand.siteName,
    type: 'website',
    canonical: brand.canonicalOrigin,
    twitterSite: brand.twitterSite,
    twitterImage: brand.previewImageUrl, // dedicated image for previews
  };
};
